// extracted by mini-css-extract-plugin
export default {"firstLine":"Title_firstLine__w8nV9"};